import { useEffect, useState } from 'react';
import GalleryStrip from './GalleryStrip';

// SSR renders the crawlable GalleryStrip; once the interactive gallery
// chunk arrives on the client, swap in a single commit. next/dynamic
// would unmount the strip and render nothing while the chunk loads —
// this keeps the strip until the gallery can mount.
export default function HydratedGallery({
  style,
  galleryImages,
  allImgDetails,
  isWebp,
  toggleLightbox,
}) {
  const [Gallery, setGallery] = useState(null);

  useEffect(() => {
    let cancelled = false;
    // Literal paths so webpack code-splits each gallery into its own
    // async chunk; repeated instances dedupe to one chunk request.
    const load =
      style === 'masonry'
        ? import('./MasonryImageGallery')
        : import('./ImageGallery');
    load
      .then(mod => {
        // () => wrapper: a bare component arg would be called as an updater
        if (!cancelled) setGallery(() => mod.default);
      })
      .catch(() => {}); // chunk failed to load — keep the static strip
    return () => {
      cancelled = true;
    };
  }, [style]);

  if (
    !galleryImages ||
    !Array.isArray(galleryImages) ||
    galleryImages.length === 0
  )
    return <></>;

  if (Gallery)
    return style === 'masonry' ? (
      <Gallery
        galleryImages={galleryImages}
        allImgDetails={allImgDetails}
        isWebp={isWebp}
        toggleLightbox={toggleLightbox}
      />
    ) : (
      <Gallery
        images={galleryImages}
        allImgDetails={allImgDetails}
        isWebp={isWebp}
        toggleLightbox={toggleLightbox}
      />
    );

  return (
    <GalleryStrip images={galleryImages} toggleLightbox={toggleLightbox} />
  );
}
